<template>
  <div class="wrapper">
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      title="DOWNLOAD FILE"
      @click="downloadFile"
    >
      <i class="material-icons-outlined align-middle">download</i>
    </a>
    <a
      class="ag-nomal-action-menu"
      href="javascript:void(0);"
      title="DELETE FILE"
      @click="deleteFile"
      v-if="user && user.roles && user.roles.admin"
    >
      <i class="material-icons-outlined align-middle">delete</i>
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    downloadFile: function () {
      this.params.context.componentParent.downloadFile(this.params.data);
    },
    deleteFile: function () {
      this.params.context.componentParent.deleteFile(this.params.data);
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
